import { render, staticRenderFns } from "./AcquisitionIndicator.vue?vue&type=template&id=b9315b48&scoped=true&"
import script from "./AcquisitionIndicator.vue?vue&type=script&lang=js&"
export * from "./AcquisitionIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9315b48",
  null
  
)

export default component.exports